import styled from 'styled-components'
import {device} from "src/theme/theme";

export const Code = styled.div`
  display: flex;

  .container {
    width: 260px;

    @media ${device.mobileL} {
      width: 300px
      margin-left: 0.5rem;
    }
  }

  .character {
    border-radius: 0.5rem;
    ${({ theme }) => ({ ...theme.typography.primary.semiBold })}
    border: 3px solid ${({ theme }) => theme.colors.secondaryBackgroundColor};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .character--inactive {
    color: ${({ theme }) => theme.colors.palette.neutral300};
    border: 3px solid ${({ theme }) => theme.colors.palette.neutral400};
    background: ${({ theme }) => theme.colors.palette.neutral300};
  }

  .character--selected {
    color: ${({ theme }) => theme.colors.secondaryBackgroundColor};
    border: 3px solid ${({ theme }) => theme.colors.secondaryBackgroundColor};
  }
`
